export default __webpack_public_path__ + "images/icx_9e5f59.svg";